(function () {
  'use strict';

  const SELECTORS = {
    gallery: '.product__media-list',
    mediaItem: '.product__media-item',
    mediaContainer: '.product-media-container',
    image: '.product__media img',
  };

  let overlay, imgEl, counter, wrapper;
  let images = [];
  let currentIndex = 0;

  // Pinch/zoom state
  let scale = 1;
  let startDistance = 0;
  let startScale = 1;
  let translateX = 0;
  let translateY = 0;
  let startTouchX = 0;
  let startTouchY = 0;
  let startTranslateX = 0;
  let startTranslateY = 0;
  let isPanning = false;
  let lastTap = 0;

  function getDistance(t1, t2) {
    return Math.hypot(t2.clientX - t1.clientX, t2.clientY - t1.clientY);
  }

  function buildOverlay() {
    overlay = document.createElement('div');
    overlay.className = 'product-lightbox-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Product image zoom');
    overlay.innerHTML = `
      <button class="product-lightbox__close" aria-label="Close">
        <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      </button>
      <span class="product-lightbox__counter"></span>
      <button class="product-lightbox__nav product-lightbox__prev" aria-label="Previous image">
        <svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"/></svg>
      </button>
      <button class="product-lightbox__nav product-lightbox__next" aria-label="Next image">
        <svg viewBox="0 0 24 24"><polyline points="9 6 15 12 9 18"/></svg>
      </button>
      <div class="product-lightbox__image-wrapper">
        <img src="" alt="Product image" />
      </div>
    `;
    document.body.appendChild(overlay);

    imgEl = overlay.querySelector('.product-lightbox__image-wrapper img');
    counter = overlay.querySelector('.product-lightbox__counter');
    wrapper = overlay.querySelector('.product-lightbox__image-wrapper');

    // Close
    overlay.querySelector('.product-lightbox__close').addEventListener('click', close);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });

    // Nav
    overlay.querySelector('.product-lightbox__prev').addEventListener('click', function (e) {
      e.stopPropagation();
      navigate(-1);
    });
    overlay.querySelector('.product-lightbox__next').addEventListener('click', function (e) {
      e.stopPropagation();
      navigate(1);
    });

    // Keyboard
    document.addEventListener('keydown', function (e) {
      if (!overlay.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') navigate(-1);
      if (e.key === 'ArrowRight') navigate(1);
    });

    // Desktop: click to toggle zoom
    wrapper.addEventListener('click', function (e) {
      if (window.innerWidth < 750) return;
      if (e.target.closest('.product-lightbox__nav')) return;
      toggleDesktopZoom(e);
    });

    // Desktop: mouse wheel zoom
    wrapper.addEventListener('wheel', function (e) {
      if (window.innerWidth < 750) return;
      e.preventDefault();
      var delta = e.deltaY > 0 ? -0.15 : 0.15;
      var newScale = Math.min(4, Math.max(1, scale + delta));
      if (newScale === 1) {
        resetZoom();
      } else {
        scale = newScale;
        applyTransform();
        wrapper.classList.add('is-zoomed');
      }
    }, { passive: false });

    // Mobile: touch events for pinch-to-zoom and swipe
    wrapper.addEventListener('touchstart', onTouchStart, { passive: false });
    wrapper.addEventListener('touchmove', onTouchMove, { passive: false });
    wrapper.addEventListener('touchend', onTouchEnd, { passive: true });
  }

  function onTouchStart(e) {
    if (e.touches.length === 2) {
      // Pinch start
      e.preventDefault();
      startDistance = getDistance(e.touches[0], e.touches[1]);
      startScale = scale;
    } else if (e.touches.length === 1) {
      // Double-tap detection
      var now = Date.now();
      if (now - lastTap < 300) {
        e.preventDefault();
        if (scale > 1) {
          resetZoom();
        } else {
          scale = 2.5;
          applyTransform();
          wrapper.classList.add('is-zoomed');
        }
        lastTap = 0;
        return;
      }
      lastTap = now;

      // Pan start (if zoomed) or swipe start
      startTouchX = e.touches[0].clientX;
      startTouchY = e.touches[0].clientY;
      startTranslateX = translateX;
      startTranslateY = translateY;
      isPanning = scale > 1;
    }
  }

  function onTouchMove(e) {
    if (e.touches.length === 2) {
      // Pinch zoom
      e.preventDefault();
      var dist = getDistance(e.touches[0], e.touches[1]);
      scale = Math.min(5, Math.max(1, startScale * (dist / startDistance)));
      applyTransform();
      if (scale > 1) {
        wrapper.classList.add('is-zoomed');
      }
    } else if (e.touches.length === 1 && isPanning) {
      // Pan while zoomed
      e.preventDefault();
      var dx = e.touches[0].clientX - startTouchX;
      var dy = e.touches[0].clientY - startTouchY;
      translateX = startTranslateX + dx;
      translateY = startTranslateY + dy;
      applyTransform();
    }
  }

  function onTouchEnd(e) {
    if (e.touches.length === 0) {
      if (scale <= 1) {
        // Check for swipe to navigate
        var dx = e.changedTouches[0].clientX - startTouchX;
        if (Math.abs(dx) > 60) {
          navigate(dx > 0 ? -1 : 1);
        }
        resetZoom();
      }
      isPanning = false;
    }
  }

  function applyTransform() {
    imgEl.style.transition = 'none';
    imgEl.style.transform = 'scale(' + scale + ') translate(' + (translateX / scale) + 'px, ' + (translateY / scale) + 'px)';
  }

  function resetZoom() {
    scale = 1;
    translateX = 0;
    translateY = 0;
    imgEl.style.transition = 'transform 0.2s ease';
    imgEl.style.transform = 'scale(1) translate(0, 0)';
    wrapper.classList.remove('is-zoomed');
  }

  function toggleDesktopZoom(e) {
    if (scale > 1) {
      resetZoom();
    } else {
      // Zoom to 2x centered on click point
      var rect = imgEl.getBoundingClientRect();
      var offsetX = e.clientX - rect.left - rect.width / 2;
      var offsetY = e.clientY - rect.top - rect.height / 2;
      scale = 2.5;
      translateX = -offsetX;
      translateY = -offsetY;
      imgEl.style.transition = 'transform 0.2s ease';
      imgEl.style.transform = 'scale(' + scale + ') translate(' + (translateX / scale) + 'px, ' + (translateY / scale) + 'px)';
      wrapper.classList.add('is-zoomed');
    }
  }

  function open(index) {
    if (!overlay) buildOverlay();
    currentIndex = index;
    showImage();
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    resetZoom();
  }

  function close() {
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    resetZoom();
  }

  function navigate(dir) {
    currentIndex = (currentIndex + dir + images.length) % images.length;
    resetZoom();
    showImage();
  }

  function showImage() {
    var src = images[currentIndex];
    if (src) {
      imgEl.src = src;
      imgEl.alt = 'Product image ' + (currentIndex + 1) + ' of ' + images.length;
    }
    counter.textContent = (currentIndex + 1) + ' / ' + images.length;
  }

  function collectImages() {
    images = [];
    var gallery = document.querySelector(SELECTORS.gallery);
    if (!gallery) return;
    gallery.querySelectorAll(SELECTORS.mediaItem).forEach(function (item) {
      var img = item.querySelector('img');
      if (!img) return;
      // Get the highest resolution URL from srcset or src
      var src = img.src || '';
      // Replace width parameter to get full size
      if (src.indexOf('cdn.shopify.com') !== -1) {
        src = src.replace(/&width=\d+/, '&width=1946');
        if (src.indexOf('&width=') === -1) {
          src += (src.indexOf('?') !== -1 ? '&' : '?') + 'width=1946';
        }
      }
      images.push(src);
    });
  }

  function init() {
    var gallery = document.querySelector(SELECTORS.gallery);
    if (!gallery) return;

    collectImages();

    gallery.querySelectorAll(SELECTORS.mediaItem).forEach(function (item, index) {
      var container = item.querySelector(SELECTORS.mediaContainer);
      if (!container) return;
      // Add click listener to the container
      container.addEventListener('click', function (e) {
        // Don't interfere with video/3d model interactions
        if (container.classList.contains('media-type-video') ||
            container.classList.contains('media-type-external_video') ||
            container.classList.contains('media-type-model')) return;
        e.preventDefault();
        e.stopPropagation();
        // Re-collect in case images changed (variant switch)
        collectImages();
        open(index);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
